import { connect } from 'react-redux';
import CompareTiles from './CompareTiles';
import { getAnnualResults } from '../selectors';

import { setSelectedFinancing } from '../../../../common/settings/actions';
import { setMosaicTerm } from '../../../../common/loan/actions';

const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    ppaRate: state.ppa.rate,
    ppaTerm: state.ppa.term,
    ppaEscalator: state.ppa.escalator,
    loanTerm: state.loan.loanTerm,
    downPayment: state.loan.downPayment,
    loanInterest: state.loan.interest,
    cashprice: state.solar.cashprice,
    systemSize: state.solar.systemSize,
    includeCash: state.cash.includeCash,
    formattedSystemPrice: state.solar.systemSize,
    provider: state.utility.provider,
    energyValue: state.utility.energyValue,
    annualInflation: state.utility.annualInflation,
    setSelectedFinancing,
    doughnutSlider: state.settings.doughnutSlider,
    projectState: state.projectaddress.projectState,
    showOBS: state.obs.showOBS,
    showPPA: state.ppa.showPPA,
    showLoan: state.loan.showLoan,
    obsTerm: state.obs.obsTerm,
    showCAP: state.cap.showCAP,
    capTerm: state.cap.capTerm,
    capDownPayment: state.cap.capDownPayment,
    obsDownPayment: state.obs.obsDownPayment,
    mosaicTerm: state.loan.mosaicTerm,
    loanProvider: state.loan.loanProvider,
    mosaicFee: state.loan.mosaicFee,
    resiToggle: state.tax.resiToggle,
    selectedFinancing: state.settings.selectedFinancing,
    mosaicDownPayment: state.loan.mosaicDownPayment,
    isLocked: state.isLockedUI.isLocked,
    firstName: state.contactUI.firstName,
    setMosaicTerm,
});

const combinedActions = {
    setSelectedFinancing,
    setMosaicTerm,
};

export default connect(mapStateToProps, combinedActions)(CompareTiles);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/CompareTiles/index.js